import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_snack_12: FaireProductEntity = {
  token: "nyc-snack-12",
  type: "product",
  name: "Cowboy Snack Mix",
  brandName: "Texas Treats",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/024055488c96e19b1ecac54a9e779fe46df0be5f1349ae598cc7deb107bf846a.jpeg",
  priceDollars: 11,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/024055488c96e19b1ecac54a9e779fe46df0be5f1349ae598cc7deb107bf846a.jpeg",
  weight: 0.5,
  dimensions: {
    width: 5,
    height: 7,
    depth: 2,
  },
  description: "A little heat & a lot of crunch - bold Texan snack mix",
  categoryTokens: ["cat_food-snacks"],
  tags: ["premium", "artisanal", "spicy"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
